/* eslint-disable react/no-unused-prop-types,react/display-name */
import { forwardRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { IconError } from '@/app/common/icons/libraryIcons';
import type { SearchParams } from '@/server/searchParams.ts';
import { useTranslation } from '@/app/components/translations/Translation';
import { PropertyNameDelete, PropertyNameMobile, PropertyNameMobileButton, PropertyNameStyled } from './styled';
import { type PropertyNameSelected, PropertyNameSelector } from './PropertyNameSelector';
import type { CommonProps } from '../CommonProps';
import { PropertyNameModal } from './PropertyNameModal';
import MagnifyingGlass from './MagnifyingGlass';

type Props = {
  searchParams: SearchParams;
  name: string;
  onUpdate: (e: PropertyNameSelected) => void;
  value: string;
  commonProps: CommonProps;
};

const PropertyNameComponent = ({ searchParams, name, onUpdate, value, commonProps }: Props) => {
  const { isMobile } = commonProps;
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const propertyNameValue = value || t('vacation.oss.filters.property.placeholder');
  const showDeleteButton = !!value;

  const handlePropertyNameClicked = () => {
    setShowModal(true);
  };

  const handleDeleteClicked = () => {
    onUpdate({ target: { name, value: '' } });
  };

  return (
    <PropertyNameStyled>
      {isMobile ? (
        <PropertyNameMobile onClick={handlePropertyNameClicked}>
          {!value && <MagnifyingGlass />}
          <PropertyNameMobileButton showDeleteButton={showDeleteButton}>{propertyNameValue}</PropertyNameMobileButton>
          {showDeleteButton && (
            <PropertyNameDelete
              type="button"
              onClick={handleDeleteClicked}
              aria-label={t('vacation.oss.filters.clear')}
            >
              <IconError size="18" />
            </PropertyNameDelete>
          )}
        </PropertyNameMobile>
      ) : (
        <PropertyNameSelector
          searchParams={searchParams}
          name={name}
          onUpdate={onUpdate}
          value={value}
          isMobile={isMobile}
        />
      )}
      {showModal &&
        ReactDOM.createPortal(
          <PropertyNameModal
            searchParams={searchParams}
            name={name}
            onUpdate={onUpdate}
            value={value}
            setShowModal={setShowModal}
            isMobile={isMobile}
          />,
          document.querySelector('[data-openx-modal-paper]') || document.body
        )}
    </PropertyNameStyled>
  );
};

export default forwardRef((props: Props, ref) => <PropertyNameComponent {...{ innerRef: ref, ...props }} />);
